export default "<div class=\"container\">\n  <app-sokepolicy></app-sokepolicy>\n</div>";